import { render } from "./MenuDesktopList.vue?vue&type=template&id=50e1363e&scoped=true&ts=true"
import script from "./MenuDesktopList.vue?vue&type=script&lang=ts"
export * from "./MenuDesktopList.vue?vue&type=script&lang=ts"

import "./MenuDesktopList.vue?vue&type=style&index=0&id=50e1363e&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e1363e"]])

export default __exports__